export default function isYearValid(year: number, oldestYear: number) {
  const currentYear = new Date().getFullYear();
  if (year > currentYear || year < oldestYear) {
    return false;
  }
  return true;
}
